export interface DistributionChannel<T = BrokerId> {
  insuranceId: string;
  name: string;
  links: {
    logo: string;
  };
  vermittlernummern: T[];
}

export type BrokerIdResponse = Omit<BrokerId, 'isSelected'>;

export interface BrokerId {
  vermittlerName: string;
  vermittlernummer: string;
  typ: string;
  status: string;
  isVerkettet: boolean;
  isSelected: boolean;
  productComboIds: Record<string, string>;
}

export interface DistributionPool<T = BrokerId> {
  name: POOL;
  label: string;
  links: {
    logo: string;
    eula?: string;
    callback?: string;
  };
  vnAvailable?: boolean;
  preferred?: boolean;
  vermittlernummern: T[];
}

export enum DISTRIBUTION_WAY {
  // Generate contract via pool.
  USE_POOL = 'pooling',
  // Generate contract via insurance company.
  // This will request a new broker ID if non is present.
  USE_COMPANY = 'company',
  // Use another distribution channel via another insurance
  //  company where they already got a valid broker ID.
  USE_RELATED_COMPANY = 'relatedCompany',
}

export interface CompanyDistributionSettings {
  channels: DistributionChannel[];
  pools: DistributionPool[];
  selection: {
    channel: string | null;
    pool: string | null;
    method: DISTRIBUTION_WAY;
  };
}

export interface DistributionApiResponse {
  vertriebswege: DistributionChannel<BrokerIdResponse>[];
  pools: DistributionPool<BrokerIdResponse>[];
}

export enum POOL {
  FONDS_FINANZ = 'fondsfinanz',
  QUALITY_POOL = 'quality',
  JDC = 'jdc',
}
